<template>
    <div class="container">

        <!-- Loading加载 -->
        <div class="loading" v-if="isDetail">
            <van-loading size="40px" type="spinner" color="#39CCCD" vertical>
                <div class="loading-text">
                    <div>页面正在加载</div>
                    <div>请稍候</div>
                </div>
            </van-loading>
        </div>

        <!-- 详情 -->
        <div class="content" v-html="detail.detail" v-show="!isDetail">
        </div>
        <div class="footer-fit" v-if="detail.id && !isDetail">
            <div class="bottom" @click.stop="returnWX()">
                <div class="bottom2">马上报名</div>
            </div>
        </div> 

        <!-- 页面前往微信 -->
        <div class="qianwang_mengceng" v-if="!isDetail && isQianwang" @click="isQianwang = false">
            <div class="qianwang" @click="isQianwang = true">
                <div class="qw_top">
                    <img src="@/assets/logo1.png" class="img_log" />
                    <div class="dotting">
                        <div :class="dot == 1 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot == 2 ? 'yuan' : 'yuan2'"></div>
                        <div :class="dot >= 3 ? 'yuan' : 'yuan2'"></div>
                    </div>
                    <img src="@/assets/weixin_logo.png" class="img_log" />
                </div>
                <div style="padding-top: 25px;">即将前往微信小程序完成领取噢~</div>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"></script>
<script type="module" src="@/utils/uni.weiview156.js"></script>

<script>
var that;
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'; 
export default {
    name: 'index_three',
    components: {},
    props: {},
    data() {
        return {
            id: '',
            bdVid: '',
            keywordid: '',
            isDetail: true,
            detail: {}, 
            isQianwang: false,
            dot: 1,
        }
    },
    computed: {},
    created() {
        that = this
        that.id = this.$route.query.channel_id;
        that.bdVid = this.$route.query.bd_vid || this.$route.query.bdVid || '';
        that.keywordid = this.$route.query.keywordid || '';
        if (!that.isWeixin()) {
            that.returnWX();
        }
        that.getDetail() 
    },
    watch : {
        'isQianwang'(x,j) {
            if(x){
                setInterval(() => {
                    that.dot++
                    if(that.dot > 3){
                        that.dot = 1
                    }
                }, 300);
            }
        }
    },
    methods: {  
        isWeixin() {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                wx.miniProgram.getEnv((res) => {
                console.log(res)
                    if (res.miniprogram) {
                        console.log('在小程序里')
                        return true;
                    } else {
                        console.log('不在小程序里')
                        return false;
                    }
                })
            } else {
                console.log('不在微信里3')
                return false;
            }
        },

        async getDetail() {
            const res = await this.$http.get('/app/channels/getInfo', {
                id: this.id
            })
            console.log(res)
            if (res.code == 200) {
                this.detail = res.data;
                this.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
                this.detail.deduct = 99.9;
                this.detail.couponName = '学习红包';
                // this.getCoursesDetail(res.data.courseId)

                document.title = res.data.title;
                setTimeout(() => {
                    this.isDetail = false;
                }, 500);
            } else {
                setTimeout(() => {
                    this.isDetail = false;
                    Toast('网络出现问题，请刷新重试!');
                }, 3000);
            }
        },

        // 获取课程详情
        getCoursesDetail(id) {
            var that = this;
            this.$http.get('/u/app/courses/detail', {
                id: id
            }).then(res => {
                console.log("数据" + res)
                that.detail.purchased = res.data.purchased; 
            })
        }, 

        //跳转微信小程序打开
        returnWX() {   
            this.isQianwang = true;
            setTimeout(() => {
                this.isQianwang = false;
            }, 5000);
            this.$http.get('/u/app/bd/getMaScheme', {
                bdVid: this.bdVid,
                keywordId: this.keywordid,
                channelId: this.id,
                path: 'packageB/pages/baidu3/index'
            }).then(res => {
                console.log(res)
                window.location.href = res.data;
            })
        },  
    }
}
</script>

<style scoped lang="less">
.qianwang_mengceng {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 10076;

    .qianwang {
        position: fixed;
        left: 50%;
        top: 25%;
        transform: translate(-50%, -50%);
        background-color: #fff;
        border-radius: 16px;
        width: 84%;
        padding: 50px;
        font-size: 32px;
        color: #666;
        transition: all 0.3s ease;
        text-align: center;

        .qw_top {
            display: flex;
            align-items: center;
            justify-content: space-around;

            .img_log {
                width: 80px;
                height: 80px;
            }

            .dotting {
                display: flex;
                align-items: center;
                justify-content: space-around;
                width: 100px;

                .yuan {
                    width: 18px;
                    height: 18px;
                    border-radius: 20px;
                    background-color: #686868;
                    transition: all 0.3s ease;
                }

                .yuan2 {
                    width: 12px;
                    height: 12px;
                    border-radius: 20px;
                    background-color: #c5c5c5;
                    transition: all 0.3s ease;
                }
            }
        }
    }
}

@keyframes van-fade-out {
    0% {
        opacity: 1
    }

    to {
        opacity: 0
    }
}

.danmu {
    position: fixed;
    top: 20vh;
    left: 5vw;
    padding: 10px 20px;
    background: #00000075;
    color: #fff;
    font-size: 24px;
    border-radius: 50px;
}

.fade-in {
    animation: slide-up-fade-in 0.5s forwards;
}

@keyframes slide-up-fade-in {
    0% {
        transform: translateY(10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.fade-out {
    animation: slide-up-fade-out 2s forwards;
}

@keyframes slide-up-fade-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-30px);
        opacity: 0;
    }
}

.content img {
    pointer-events: none;
    cursor: default;
}

.loading {
    margin: 40vh auto;
    text-align: center;

    .loading-text {
        color: #39CCCD;
        font-weight: bold;
    }
}

.container {
    color: #333;
    font-size: 28px;
    // height: 100vh !important;
    height: 100%;
    display: flex;
    flex-direction: column;

    .content {
        flex: 1;
        position: relative;
        // padding-bottom: 140px;
        // height: 100vh !important; 
        overflow-y: auto;
        width: 100%;

        ::v-deep img {
            display: block;
            width: 100% !important;
        }
    }
}

.header-bg {
    width: 100vw;
}

.footer-fit {
    flex-shrink: 0;
    // position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    // background-color: rgb(255, 250, 240);
    background-color: #ffffff;

    .bottom {
        padding: 20px 30px 30px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ff6033;

        .bottom2 {
            padding: 30px;
            background-color: red;
            line-height: 40px;
            font-weight: bold;
            font-size: 44px;
            width: 100%;
            border-radius: 100px;
            text-align: center;
            color: #ffffff;
        }
    }

    .left {
        // color: rgb(255, 36, 0);
        color: #ffffff;
        font-size: 42px;
        line-height: 40px;
        font-weight: 600;

        .left-qian {
            font-size: 45px;
            font-family: sans-serif;
        }
    }

    .right {
        position: relative;

        .finger {
            width: 100px;
            height: 100px;
            position: absolute;

            left: -60px;
            top: 50%;
            margin-top: -50px;

            z-index: 1;
            -webkit-animation: fadefinger 0.4s ease infinite alternate;
            animation: fadefinger 0.4s ease infinite alternate;
        }

        @keyframes identifier {
            0% {
                transform: scale(.95);
            }

            50% {
                transform: scale(1.02);
            }

            100% {
                transform: scale(.95);
            }
        }

        .btn {
            background-color: red;
            color: #fff;
            font-weight: 600;
            width: 300px;
            height: 100px;
            line-height: 100px;
            border-radius: 50px;
            text-align: center;
            animation: identifier .7s linear infinite;
            font-size: 44px;

            .grab {
                font-size: 22px;
                line-height: 22px;
                margin-bottom: 10px;
                padding-top: 10px;
            }

            .enroll {
                // line-height: 44px;
                line-height: 40px;
                font-weight: bold;
                font-size: 44px;
            }
        }
    }
}

@keyframes fadefinger {
    0% {
        transform: translateX(35px);
        -webkit-transform: translateX(35px);
    }

    100% {
        transform: translateX(0);
        -webkit-transform: translateX(0);
    }
}

@keyframes updown {
    0% {
        transform: translateY(8px);
        -webkit-transform: translateY(8px);
    }

    100% {
        transform: translateY(-8px);
        -webkit-transform: translateY(-8px);
    }
}


.van-popup {
    background: #f4f4f4;
}

.active {
    border: 4px solid #ff6d00 !important;
}
</style>